import { render, staticRenderFns } from "./NotificacionesPage.vue?vue&type=template&id=49cbe456"
import script from "./NotificacionesPage.js?vue&type=script&lang=js&external"
export * from "./NotificacionesPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports